module.exports = __webpack_public_path__ + "static/img/Fridge Magnet 2-2.cc7cc19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Fridge Magnet 2-2.jpg
// module id = lKNT
// module chunks = 1